import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const templateRoutes: Routes = [];
@NgModule({
    imports: [RouterModule.forChild(templateRoutes)],
    exports: [RouterModule]
})
export class TemplateRoutingModule { }
